import { render, staticRenderFns } from "./Revisions.vue?vue&type=template&id=ba25e29c&"
import script from "./Revisions.vue?vue&type=script&lang=ts&"
export * from "./Revisions.vue?vue&type=script&lang=ts&"
import style0 from "./Revisions.vue?vue&type=style&index=0&id=ba25e29c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports